/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgButton = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m11.275 11.17 7 2.034a1.024 1.024 0 0 1 .28 1.824l-1.986 1.344 3.138 3.19L18.293 21l-3.138-3.19-1.323 2.019a.995.995 0 0 1-.986.44 1.003 1.003 0 0 1-.807-.726l-2-7.116a1.024 1.024 0 0 1 .254-.997.993.993 0 0 1 .982-.26zM23 3v14h-3v-2h1V5H3v10h6v2H1V3zM12.456 13.629l.912 3.243.8-1.221a1.01 1.01 0 0 1 .277-.282l1.201-.814z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgButton as Button };
